import { render, staticRenderFns } from "./FamousPediaEditHistory.vue?vue&type=template&id=8fe97f48&"
import script from "./FamousPediaEditHistory.vue?vue&type=script&lang=js&"
export * from "./FamousPediaEditHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports